export const storeProcessTaskTypes = [
  'CLEANING',
  'RECEPTION',
  'LIVRAISON',
  'INVENTORY',
  'CLIENT_RELATION',
] as const
export type StoreProcessTaskType = (typeof storeProcessTaskTypes)[number]

export const storeProcessTaskTypeLabel: Record<StoreProcessTaskType, string> = {
  CLEANING: 'Nettoyage',
  RECEPTION: 'Réception',
  LIVRAISON: 'Livraison',
  INVENTORY: 'Inventaire',
  CLIENT_RELATION: 'Relation client',
}
